import styled from "styled-components";

/**
 * The library Label forces white text via `customColor` and ignores `textColor`
 * in this build, so set the color here. Its `circular` variant also forces 1px
 * letter-spacing via `.ui.label.circular span`; `<FormattedMessage>` (react-intl
 * v2) renders its text in a nested span that matches that rule too, so the
 * letter-spacing override targets this element and its descendant spans.
 */
export const LabelText = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  white-space: nowrap;

  &,
  & span {
    letter-spacing: 0 !important;
  }
`;
